export default "__VITE_ASSET__B6ixqS1s__"